import { FormItemType } from './enums'
import { VOICE_MESSAGE_MAX_COUNT } from './validationConfig'

// The name carries the recording's number across the whole case and is assigned once, at
// submission. It is never rewritten afterwards: a redacted copy reuploads the recordings under
// the same names, so "voice message 7" points at the same recording wherever it shows up.
const voiceRecordingNamePattern = /^\d{8}_voice_message_\d+\.mp3$/
// Recordings submitted before the numbered format. They carry no number, so they fall back to
// their position in the answer.
const legacyVoiceRecordingNamePattern = /^VoiceRecord_\d{6}\.mp3$/

export const generateVoiceRecordingName = ({
  date,
  number,
}: {
  /** Submission date as `YYYYMMDD` */
  date: string
  number: number
}) => `${date}_voice_message_${number}.mp3`

export const isVoiceRecordingName = (name: string) =>
  voiceRecordingNamePattern.test(name) || legacyVoiceRecordingNamePattern.test(name)

// A short answer holds one thought, so it takes a single recording. Longer fields keep the
// full allowance.
export const maxVoiceRecordingsForFormItemType = (formItemType: FormItemType) =>
  formItemType === FormItemType.SimpleText ? 1 : VOICE_MESSAGE_MAX_COUNT

export type VoiceRecordingFilesProblem = 'tooMany' | 'nonVoiceFile'

// Single source of truth for the voice-message rules. Every submission path enforces them
// (AF_FormAnswersService, ReportContent, ReportAnswerService), each reporting the problem in
// its own error style.
export const findVoiceRecordingFilesProblem = (
  filenames: string[],
  maxCount = VOICE_MESSAGE_MAX_COUNT
): VoiceRecordingFilesProblem | null => {
  if (filenames.length > maxCount) {
    return 'tooMany'
  }
  if (filenames.some(filename => !isVoiceRecordingName(filename))) {
    return 'nonVoiceFile'
  }
  return null
}
